"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LoggerConfig = {};
LoggerConfig.set = function (options) {
  LoggerConfig.verboseEvents = options.verboseEvents;
  LoggerConfig.enable = options.enable;
};
var _default = LoggerConfig;
exports.default = _default;
//# sourceMappingURL=logger-config.js.map
